module.exports = __webpack_public_path__ + "img/platform4.fad70100.png";